// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uHtU0mZgHIQYXkUQwRhP {
  display: flex;
  align-items: center;
  gap: 0.5em;
}
.uHtU0mZgHIQYXkUQwRhP > i {
  font-size: 2em;
}
.uHtU0mZgHIQYXkUQwRhP small {
  display: block;
  font-size: 0.8em;
  opacity: 0.6;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flag": `uHtU0mZgHIQYXkUQwRhP`
};
export default ___CSS_LOADER_EXPORT___;
